export default __webpack_public_path__ + "static/media/map-marker-car-white-background.d9b1b26d.svg";